import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DxauthService } from 'src/app/dxauth.service';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { Auth0Service } from 'src/app/shared/services/auth0.service';

@Component({
  selector: 'app-collabo-portal-dxsales-forgot-password',
  templateUrl: './collabo-portal-dxsales-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './collabo-portal-dxsales-forgot-password.component.css',
  ]
})
export class CollaboPortalDxsalesForgotPasswordComponent
  extends BaseLoginComponent implements OnInit {
  constructor(
    protected activateRoute: ActivatedRoute,
    auth0: Auth0Service,
    dxauth: DxauthService,
    protected spinner: NgxSpinnerService,
    public router: Router,
    public title: Title) {
    super(activateRoute, auth0, dxauth, spinner, router, title);
    title.setTitle('パスワード再設定 メールアドレス入力');
  }
  async init(): Promise<void> { }
}
